import { useCallback, useState } from 'react';
import { useFieldActions } from '../../../contexts/field-actions-context';
import { FORM_STATUS, useFormStatus } from '../../../contexts/form-status-provider';
export const useSubmitButton = _ref => {
  let {
    text,
    submitText
  } = _ref;
  const {
    inProgress,
    actions
  } = useFieldActions();
  const [submitInProgress, setSubmitInProgress] = useState(false);
  const {
    formStatus
  } = useFormStatus();
  const submitButtonText = submitText || text || '';
  const isDisabled = submitInProgress;
  const isInProgress = inProgress || formStatus === FORM_STATUS.BUSY;
  const handleSubmitClick = useCallback(async () => {
    if (isInProgress) {
      return;
    }
    setSubmitInProgress(true);
    try {
      await (actions == null ? void 0 : actions.submitForm());
    } catch (error) {
      console.error(error);
    }
    setSubmitInProgress(false);
  }, [actions, isInProgress]);
  return {
    handleSubmitClick,
    isDisabled,
    isInProgress,
    submitButtonText
  };
};
//# sourceMappingURL=use-submit-button.js.map